import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams, type UploadAnalyticsFailedStage } from './uploadAnalyticsTypes';
import META from './useTrackUploadError.meta';

export type UseTrackUploadErrorParams = UploadAnalyticsCommonParams & {
  upload_duration_ms?: number;
  error_message: string;
  error_name?: string;
  error_status_code?: number;
  is_retryable?: boolean;
  failed_stage: UploadAnalyticsFailedStage;
  upload_url_type?: 'primary' | 'fallback' | 'mixed';
};

export const useTrackUploadError = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadError = useCallback(
    (params: UseTrackUploadErrorParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadError };
};
